import { Controller } from "@hotwired/stimulus"

/**
 * "Show recommendations" toggle over the task form's Site picker — the Hotwire
 * counterpart of React's CompanySelectorWithSuggestions (CONEK-7690). Rendered
 * by pipeline/tasks/_form_fields only when the surface passes
 * `recommended_companies` (the calendar task drawer: the booking's external
 * participants' Sites).
 *
 *   ON  (default) → the `recommended` block: a plain select over those Sites.
 *   OFF           → the `all` block: the normal Site search.
 *
 * Both blocks carry a `task[contact_company_ids][]` field, so the hidden one's
 * inputs are DISABLED — a disabled control is neither submitted nor
 * constraint-validated, so exactly one Site posts and only the visible picker's
 * `required` bites.
 */
export default class extends Controller {
  static targets = ["recommended", "all", "hint"]

  connect() {
    this._apply(this._checked())
  }

  toggle() {
    this._apply(this._checked())
    // The effective Site may have changed with the swap — say so, so a
    // Site-dependent listener (pipeline--task-form-reload) re-evaluates.
    const active = (
      this._checked() ? this.recommendedTarget : this.allTarget
    ).querySelector("[name='task[contact_company_ids][]']")
    active?.dispatchEvent(new Event("change", { bubbles: true }))
  }

  _checked() {
    const checkbox = this.element.querySelector("input[type='checkbox']")
    return checkbox ? checkbox.checked : true
  }

  _apply(showRecommended) {
    this._setActive(this.recommendedTarget, showRecommended)
    this._setActive(this.allTarget, !showRecommended)
    if (this.hasHintTarget) {
      const title = showRecommended
        ? this.hintTarget.dataset.onTitle
        : this.hintTarget.dataset.offTitle
      if (title) this.hintTarget.title = title
    }
  }

  _setActive(block, active) {
    block.hidden = !active
    block
      .querySelectorAll("input[name], select[name], textarea[name]")
      .forEach((field) => {
        field.disabled = !active
      })
  }
}
